module.exports = __webpack_public_path__ + "img/right-side-menu-outputs.5fff221f.svg";